import {
  ButtonHTMLAttributes,
  ComponentPropsWithRef,
  ComponentType,
  FunctionComponent,
} from "react";
import clsx from "clsx";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  leadingIcon?: ComponentType<ComponentPropsWithRef<"svg">>;
}
const LinkButtonBlue: FunctionComponent<ButtonProps> = ({
  className,
  disabled,
  children,
  leadingIcon: LeadingIcon,
  ...htmlButtonAttributes
}) => {
  return (
    <button
      {...htmlButtonAttributes}
      disabled={disabled}
      className={clsx(
        className,
        "tw-mb-0 my-feed-link-button tw-text-base hover:tw-no-underline",
        disabled && "tw-cursor-not-allowed",
      )}
    >
      {LeadingIcon && <LeadingIcon className="-tw-ml-1 tw-h-5 tw-w-5" aria-hidden="true" />}
      {children}
    </button>
  );
};

export default LinkButtonBlue;
